import { render, staticRenderFns } from "./huilu.vue?vue&type=template&id=9a139a68&scoped=true&"
import script from "./huilu.vue?vue&type=script&lang=js&"
export * from "./huilu.vue?vue&type=script&lang=js&"
import style0 from "./huilu.vue?vue&type=style&index=0&id=9a139a68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a139a68",
  null
  
)

export default component.exports